<!-- Modal -->
<div class="modal-dialog modal-dialog-centered mail-modal policy-acceptance-dialog">
	<div class="modal-content">
		<div class="modal-body position-relative">
			<div class="text-center p-2 mail-verfication-wrap" id="step1">
				<div class="terms-icon-wrap">
					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
						<path
							d="M20.2679 3.78694C18.2179 2.76696 15.7093 2.16699 13 2.16699C10.2907 2.16699 7.78212 2.76696 5.73209 3.78694C4.72678 4.28714 4.22412 4.53724 3.73707 5.32359C3.25 6.10995 3.25 6.87135 3.25 8.39414V12.1738C3.25 18.3309 8.17089 21.7541 11.0208 23.2203C11.8156 23.6292 12.213 23.8337 13 23.8337C13.787 23.8337 14.1844 23.6292 14.9791 23.2203C17.8291 21.7541 22.75 18.3309 22.75 12.1738V8.39414C22.75 6.87136 22.75 6.10996 22.2629 5.32359C21.7759 4.53723 21.2732 4.28714 20.2679 3.78694Z"
							fill="#FF9500" />
						<path
							d="M9.41992 13.5996C9.41992 13.5996 11.1533 14.5882 12.0199 16.0371C12.0199 16.0371 13.11 11.8597 16.5767 9.96387"
							stroke="white" stroke-width="1.625" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
				</div>

				<h3 class="terms-title">We've updated our terms</h3>
				<p class="terms-subtitle">Our privacy policy and terms of service have changed. Take a moment to review
					them, then agree to keep using RealWorld.</p>
				<div class="terms-content">
					<div class="terms-links">
						<a rel="noopener" target="_blank" href="{{docUrl?.['privacy-policy_url']}}"
							class="terms-link-card">
							<span class="terms-link-icon">
								<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
									fill="none">
									<path
										d="M12.4579 13.2447L11.625 16.5L13.5 15.75L15.375 16.5L14.625 13.199M15.75 11.25C15.75 12.4927 14.7427 13.5 13.5 13.5C12.2573 13.5 11.25 12.4927 11.25 11.25C11.25 10.0073 12.2573 9 13.5 9C14.7427 9 15.75 10.0073 15.75 11.25Z"
										stroke="#162642" stroke-width="1.125" stroke-linecap="round"
										stroke-linejoin="round" />
									<path
										d="M14.9999 7.49902C14.9999 4.67059 14.9999 3.25639 14.1212 2.3777C13.2426 1.49902 11.8283 1.49902 8.99995 1.49902H8.25002C5.42162 1.49902 4.00742 1.49902 3.12874 2.37769C2.25006 3.25636 2.25005 4.67056 2.25002 7.49897L2.25 10.4989C2.24998 13.3274 2.24996 14.7416 3.12864 15.6203C4.00733 16.499 5.42155 16.499 8.25002 16.499H9.74995"
										stroke="#162642" stroke-width="1.125" stroke-linecap="round"
										stroke-linejoin="round" />
									<path d="M5.625 5.25098H11.625M5.625 9.00098H9" stroke="#162642"
										stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</span>
							<span class="terms-link-text">
								<span class="terms-link-title">Privacy policy</span>
								<span class="terms-link-desc">What we collect and how it's protected</span>
							</span>
							<span class="terms-link-arrow">
								<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
									fill="none">
									<path
										d="M10.5 7.75838C10.5 7.75838 18.5947 7.1252 19.7346 8.26508C20.8745 9.40496 20.2412 17.4997 20.2412 17.4997M19.25 8.74968L7.58334 20.4163"
										stroke="#AEAEB2" stroke-width="1.75" stroke-linecap="round"
										stroke-linejoin="round" />
								</svg>
							</span>
						</a>
						<div class="divider"></div>

						<a target="_blank" rel="noopener" href="{{docUrl?.['user-agreement_url']}}"
							class="terms-link-card">
							<span class="terms-link-icon">
								<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
									fill="none">
									<path d="M9 3.74902V16.499M9 16.499H6.75M9 16.499H11.25" stroke="#162642"
										stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
									<path d="M15.7523 9.74902L13.8773 5.99902L12.0023 9.74902" stroke="#162642"
										stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
									<path d="M6 9.74902L4.125 5.99902L2.25 9.74902" stroke="#162642"
										stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
									<path
										d="M3.00234 5.99902H3.78849C4.73609 5.99902 5.65547 5.60227 6.39542 4.87402C7.91949 3.37402 10.0852 3.37402 11.6093 4.87402C12.3492 5.60227 13.2686 5.99902 14.2162 5.99902H15.0023"
										stroke="#162642" stroke-width="1.125" stroke-linecap="round"
										stroke-linejoin="round" />
									<path
										d="M13.875 12.751C14.891 12.751 15.7758 12.1257 16.2355 11.2022C16.4835 10.7036 16.6075 10.4544 16.3811 10.1027C16.1547 9.75098 15.78 9.75098 15.0305 9.75098H12.7195C11.97 9.75098 11.5953 9.75098 11.3689 10.1027C11.1424 10.4544 11.2665 10.7036 11.5145 11.2022C11.9742 12.1257 12.859 12.751 13.875 12.751Z"
										stroke="#162642" stroke-width="1.125" />
									<path
										d="M4.12266 12.751C5.13869 12.751 6.02347 12.1257 6.4831 11.2022C6.73117 10.7036 6.8552 10.4544 6.62879 10.1027C6.40237 9.75098 6.02766 9.75098 5.27822 9.75098H2.9671C2.21766 9.75098 1.84294 9.75098 1.61653 10.1027C1.39012 10.4544 1.51414 10.7036 1.76221 11.2022C2.22184 12.1257 3.10662 12.751 4.12266 12.751Z"
										stroke="#162642" stroke-width="1.125" />
									<path
										d="M10.125 2.62402C10.125 3.24535 9.6213 3.74902 9 3.74902C8.3787 3.74902 7.875 3.24535 7.875 2.62402C7.875 2.0027 8.3787 1.49902 9 1.49902C9.6213 1.49902 10.125 2.0027 10.125 2.62402Z"
										stroke="#162642" stroke-width="1.125" />
								</svg>
							</span>
							<span class="terms-link-text">
								<span class="terms-link-title">Terms of service</span>
								<span class="terms-link-desc">The agreement that governs your account</span>
							</span>
							<span class="terms-link-arrow">
								<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
									fill="none">
									<path
										d="M10.5 7.75838C10.5 7.75838 18.5947 7.1252 19.7346 8.26508C20.8745 9.40496 20.2412 17.4997 20.2412 17.4997M19.25 8.74968L7.58334 20.4163"
										stroke="#AEAEB2" stroke-width="1.75" stroke-linecap="round"
										stroke-linejoin="round" />
								</svg>
							</span>
						</a>
					</div>
				</div>

				<p class="terms-note">*Agreeing means you accept the updated privacy policy and terms.</p>

				<!-- agree button : Privacy Policy and Agreement (SIGNATURE REQUIRED) -->
				<div class="form-group mb-3">
					<div class="signature-container" *ngIf="isPendingSignature">
						<div class="alert-signature ">
							<div class="flex">
								<div class="flex-shrink-0">
									<svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
										xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 alert-svg">
										<path clip-rule="evenodd"
											d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
											fill-rule="evenodd"></path>
									</svg>
								</div>
								<div class="alert-prompt-wrap">
									<span class="text-sm text-yellow-700 blink-soft">
										A signing request is pending. Please open
										MetaMask to review
										and complete the
										process.
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="d-flex gap-3 flex-wrap"
					[ngClass]="{'justify-content-end':isCancelOption , 'justify-content-between':!isCancelOption , 'disabled':submitted}">
					<button (click)="closePrivecyModal()" type="button" class="onboard_cancel"
						data-bs-dismiss="modal">Cancel.</button>
					<button [disabled]="submitted" type="submit" class="onboard_verify"
						[ngClass]="{'disabled':submitted}" (click)="triggerSignatureRetrieval()">{{submitted
						?'Processing...':'Agree & continue.'}}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>